import { Location } from './location';
import { Resume } from './resume/resume';
import { Thumbnail } from './applications/thumbnail';
import { Order } from './order';
import { DEFAULT_PROJECT_TITLE } from 'src/app/services/helpers/project-title.helper';

export abstract class Configuration2D {
  public id: string;
  public title: string;
  public customerId: string;

  public creatorId: string;
  public creationTime: Date;

  //public modificatorId: string;
  public lastModificationTime: Date;

  public abstract location: Location;

  /**
   * Indique si la configuration a un devis de valide
   */
  hasQuotation: boolean;

  /**
   * Valeur calculer dans le back indiquant si la configuration contient un produit disabled
   */
  hasDisabledProducts: boolean;

  public thumbnail: Thumbnail;

  public manualDiscount?: boolean;
  public contactedByPhone?: boolean;
  public orders?: Order[];

  inTunnel: boolean;

  tunnelId?: string;
  tunnelContext?: string;
  constructor() {
    this.title = DEFAULT_PROJECT_TITLE;
  }

  onCreate(vendorId: string): void {
    this.creatorId = vendorId;
  }

  onUpdate(vendorId: string): void {
    //this.modificatorId = vendorId;
  }

  abstract set resume(resume: Resume);
}
